import React from "react";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Checkbox, ListItemText } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { i18n } from "../../translate/i18n";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  menuListItem: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  menuItem: {
    maxHeight: 30,
  },
  queueSelectContainer: {
    flex: "none",
  },
  // Pill "Filas: Todas" do mockup Aeros: border 1px, radius 9,
  // padding 7px 12px, 12px/600 textSecondary + expand_more 16px.
  pillSelect: {
    border: `1px solid ${theme.palette.aeros.borderStrong}`,
    borderRadius: 9,
    "&:before, &:after": {
      display: "none",
    },
    "& .MuiSelect-root": {
      padding: "7px 30px 7px 12px",
      fontSize: 12,
      fontWeight: 600,
      color: theme.palette.text.secondary,
      lineHeight: "16px",
      minHeight: 0,
      backgroundColor: "transparent !important",
    },
  },
  pillIcon: {
    fontSize: 16,
    color: theme.palette.text.secondary,
    right: 10,
    top: "calc(50% - 8px)",
    position: "absolute",
    pointerEvents: "none",
  },
}));

const TicketsQueueSelect = ({
  userQueues,
  selectedQueueIds = [],
  onChange,
}) => {
  const classes = useStyles();

  const handleChange = (e) => {
    onChange(e.target.value);
  };

  const renderLabel = () => {
    const total = userQueues?.length || 0;
    const allSelected =
      selectedQueueIds.length === 0 || selectedQueueIds.length === total;
    const value = allSelected
      ? i18n.t("ticketsQueueSelect.all")
      : selectedQueueIds.length;
    return `${i18n.t("ticketsQueueSelect.placeholder")}: ${value}`;
  };

  return (
    <div className={classes.queueSelectContainer}>
      <FormControl margin="none">
        <Select
          multiple
          displayEmpty
          value={selectedQueueIds}
          onChange={handleChange}
          className={classes.pillSelect}
          classes={{ icon: classes.pillIcon }}
          IconComponent={ExpandMoreIcon}
          disableUnderline
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "right",
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            getContentAnchorEl: null,
            MenuListProps: {
              className: classes.menuListItem,
            },
          }}
          renderValue={renderLabel}
        >
          {userQueues?.length > 0 &&
            userQueues.map((queue) => (
              <MenuItem
                dense
                key={queue.id}
                value={queue.id}
                className={classes.menuItem}
              >
                <Checkbox
                  style={{
                    color: queue.color,
                  }}
                  size="small"
                  color="primary"
                  checked={selectedQueueIds.indexOf(queue.id) > -1}
                />
                <ListItemText
                  primary={queue.name}
                  classes={{ primary: classes.listItemText }}
                />
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default TicketsQueueSelect;
